<template>
     <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">
              <span class="badge badge-pill badge-danger">LIVE Status</span>
            </h5>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>

              <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <div class="card-footer">
            <div class="row">
              <div class="col-sm-4 col-12">
                <div class="description-block d-flex flex-column">
                  <div>
                    <i class="fas fa-link mx-2"></i>Connection Status
                  </div>
                  <div class="badge badge-pill p-2 mx-3 mt-2" 
                  :class="live.is_live ? 'badge-danger' : 'badge-secondary'"
                  v-html="live.is_live ? '<h6>Connected</h6>' : '<h6>Not Connected</h6>'">
                  </div>
                </div>
              </div>
              <!-- /.col -->

              <!-- /.col -->
              <div class="col-sm-6 col-12">
                <div class="description-block">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td>Username:</td>
                        <td class="float-left">
                          <span id="frontend_source_pw">{{station.dj_username}}</span>
                          <copy-to-clipboard-button target="#frontend_source_pw" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                      <tr>
                        <td>Password:</td>
                        <td class="float-left">
                          <span id="frontend_relay_pw">{{station.dj_password}}</span>
                          <copy-to-clipboard-button target="#frontend_relay_pw" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                       
                    </tbody>
                  </table>
                </div>
                <!-- /.description-block -->
              </div>
            </div>
            <!-- /.row -->
          </div>
          <!-- /.card-footer -->
        </div>
        <!-- /.card -->
      </div>
</template>

<script>
import CopyToClipboardButton from '@/components/common/CopyToClipboardButton';

export default {
  
  components:{
    CopyToClipboardButton

  }
}
</script>
<style scoped>
.table th, .table td {
  
    border-top: none
}
</style>